<template>
  <ProSpaceGeoLayout>
    <template #top>
      <ProSpaceFilterPanel
        :searchPlaceholder="$t('searchTxt')"
        :unicKeyStorage="false"
        @apply="submitFilter"
        ref="filter-panel"
        filter-model="ActualModel/Value"
      >
        <template #hint> {{ $t("filterBy") }}</template>
        <template #filters="{ filter }">
          <ProSpaceCustomFilterPanel
            :customTxt="$t('custom')"
            :customFilterTxt="$t('customFilterTxt')"
            :clearFilterTxt="$t('clearTxt')"
            :selectAllTxt="$t('selectAllTxt')"
            :closeTxt="$t('closeTxt')"
            :applyTxt="$t('applyTxt')"
            :fromTxt="$t('fromTxt')"
            :toTxt="$t('toTxt')"
            :services="allCustomFilters"
            @apply="(model) => customFilterApply(filter, model)"
          />
        </template>
      </ProSpaceFilterPanel>
    </template>
    <template #center>
      <ProSpaceMainGrid
        ref="grid"
        :service="historyService"
        @selected-change="selectedHandler"
        :noMountedRequest="true"
        getMethod="grid"
        selectionMode="single"
        defaultSortField="editDate"
        defaultSortOrder="-1"
        :defaultFilter="defaultFilter"
      >
        <template #columns>
          <Column
            field="ActualModel/Value"
            :header="this.$t('areaValue')"
            sortable
            headerClass="move-sort-head"
          >
            <template #body="field">
              <ProSpaceTableHeaderCell
                v-if="field.data"
                :id="field.data.actualModel.Id"
                :status="getStatus(field.data.actualModel.Status)"
                :title="field.data.actualModel.Value"
              />
            </template>
          </Column>
          <Column field="editDate" :header="$t('changeDateTime')" sortable>
            <template #body="field">
              <ProSpaceDateTimeColumn
                v-if="field.data"
                :date="field.data.editDate"
                :dateFormat="userinfo.dateFormat"
                :timeFormat="userinfo.timeFormat"
              />
            </template>
          </Column>
          <Column field="operationType" :header="$t('operation')" sortable>
            <template #body="field">
              <ProSpaceDefaultTextColumn v-if="field.data">
                {{ field.data.operationType }}
              </ProSpaceDefaultTextColumn>
            </template>
          </Column>
          <Column field="userLogin" :header="$t('user')" sortable>
            <template #body="field">
              <ProSpaceDefaultTextColumn v-if="field.data">
                {{ field.data.userLogin }}
              </ProSpaceDefaultTextColumn>
            </template>
          </Column>
        </template>
      </ProSpaceMainGrid>
    </template>
  </ProSpaceGeoLayout>
</template>
<script>
import {
  ProSpaceMainGrid,
  ProSpaceGeoLayout,
  ProSpaceTableHeaderCell,
  ProSpaceFilterPanel,
  ProSpaceMultiSelect,
  ProSpaceCustomFilterPanel,
  ProSpaceDateColumn,
  ProSpaceDefaultTextColumn,
} from "@prospace/prospace-components-library";
import Column from "primevue/column";
import { AreaService } from "../../../services/AreaService";
const _ = require("lodash");
import { mapGetters } from "vuex";
export default {
  components: {
    ProSpaceMainGrid,
    Column,
    ProSpaceGeoLayout,
    ProSpaceTableHeaderCell,
    ProSpaceFilterPanel,
    ProSpaceMultiSelect,
    ProSpaceCustomFilterPanel,
    ProSpaceDateColumn,
    ProSpaceDefaultTextColumn,
  },
  props: {
    historyService: {
      type: Object,
      required: true,
    },
    defaultFilter: {
      type: Object,
      required: true,
    },
    historyCustomServices: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      areaService: new AreaService(),
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
    }),
    customServices() {
      return [
        {
          type: "dates-range",
          model: "ActualModel/CreatedAt",
          label: this.$t("createDate"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
        },
      ];
    },
    allCustomFilters() {
      return this.historyCustomServices.concat(this.customServices);
    },
  },
  methods: {
    getActualName(record) {
      return record.Name;
    },
    getActualId(record) {
      return record.Id;
    },
    getActualStatus(record) {
      return this.getStatus(record.Status);
    },
    openFromReference(record, fieldName) {
      this.$emit("openFromReference", record, fieldName);
    },
    emitFilter() {
      this.$refs["filter-panel"].submitFilter();
    },
    selectedHandler({ data }) {
      this.$emit("selectedHandler", data);
    },
    submitFilter({ filter, search }) {
      this.$refs.grid.submitFilter(filter, search);
    },
    getStatus(status) {
      if (!status) return;
      let type = "default";
      return {
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
        type,
      };
    },
    customFilterApply(filter, model) {
      filter = Object.assign(filter, model, this.defaultFilter);
      this.$refs["filter-panel"].submitFilter();
    },
  },
};
</script>
<style lang="scss"></style>
